import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { faqItems } from '../data/faq';
import type { FaqBlock } from '../data/faq';
function FaqBlockView({
  block
}: {
  block: FaqBlock;
}) {
  if (block.kind === 'text') {
    return <p className="mt-3 text-[15px] leading-relaxed text-ink-600" data-id="element-70" data-mp="1gdh19h35cq4b">{block.text}</p>;
  }
  if (block.kind === 'list') {
    return <ul className="mt-3 space-y-2" data-id="element-71" data-mp="2dzxtw90xqfjq">
        {block.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] leading-relaxed text-ink-600" data-id="element-72" data-mp="290tidbqjg5q8">
            <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-flare-600" aria-hidden="true" data-id="element-73" data-mp="241h0l5eixoui" />
            <span data-id="element-74" data-mp="1z3oxdf8figb0">{item}</span>
          </li>)}
      </ul>;
  }
  return <ol className="mt-3 space-y-2" data-id="element-75" data-mp="1z5jj2vriycg5">
      {block.items.map((item, index) => <li key={item} className="flex items-start gap-3 text-[15px] leading-relaxed text-ink-600" data-id="element-76" data-mp="soobk2d4bei5" data-mpi={index}>
          <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-ink-950 text-[11px] font-bold text-white" data-id="element-77" data-mp="nmgtqw5lx47w">
            {index + 1}
          </span>
          <span data-id="element-78" data-mp="ufzgvuyw3j0m">{item}</span>
        </li>)}
    </ol>;
}
export function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);
  return <section className="w-full bg-white py-20 lg:py-28" aria-labelledby="faq-heading" data-id="element-79" data-mp="kiuw9zkozvlx">
      <div className="mx-auto max-w-3xl px-6" data-id="element-80" data-mp="kko4hjayenw1">
        <h2 id="faq-heading" className="text-3xl font-black leading-tight tracking-tight text-ink-950 sm:text-4xl" data-id="element-81" data-mp="6qf09iq7kxui">
          Preguntas frecuentes
          <span className="mt-2 block text-base font-medium text-ink-500" data-id="element-82" data-mp="bk9dc3bb6ekm">
            Todas respondidas honestamente.
          </span>
        </h2>

        <div className="mt-10 divide-y divide-ink-950/10 border-y border-ink-950/10" data-id="element-83" data-mp="1rk4lg757esz">
          {faqItems.map(item => {
          const isOpen = openId === item.id;
          return <div key={item.id} data-id="element-84" data-mp="3nzbrvz7pqa31">
                <h3 data-id="element-85" data-mp="3nyiisrla78hq">
                  <button type="button" aria-expanded={isOpen} aria-controls={`${item.id}-panel`} onClick={() => setOpenId(isOpen ? null : item.id)} className="flex w-full items-center justify-between gap-6 py-5 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-flare-500/30" data-id="element-86" data-mp="3nys6u9mrn5ks">
                    <span className="text-base font-bold leading-snug text-ink-950 sm:text-lg" data-id="element-87" data-mp="1krb2mnd08bu4">
                      {item.question}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-flare-600 transition-transform duration-200 ease-swift ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-88" data-mp="2dfyskw8p7pe0" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-89" data-mp="23g7xotg878de">
                  {isOpen ? <motion.div id={`${item.id}-panel`} key="content" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-90" data-mp="1zg7jn9x1gz6v">
                      <div className="pb-6 sm:pr-8" data-id="element-91" data-mp="33q8xt4n133ie">
                        {item.blocks.map((block, index) => <FaqBlockView key={index} block={block} data-id="element-92" data-mp="38o0ro478gzp8" data-mpi={index} />)}
                      </div>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}